<template>
  <div>
    <Card>
      <template #title>My Books</template>
      <template #content>
        <DataTable :value="books" :paginator="true" :rows="10" responsiveLayout="scroll">
          <Column field="id" header="ID"></Column>
          <Column field="title" header="Title"></Column>
          <Column field="description" header="Description"></Column>
          <Column field="uploaded_at" header="Upload Date">
            <template #body="slotProps">
              {{ new Date(slotProps.data.uploaded_at).toLocaleString() }}
            </template>
          </Column>
        </DataTable>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '@/services/api';
import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

const books = ref([]);

const fetchBooks = async () => {
  try {
    const response = await api.get('/books/');
    books.value = response.data;
  } catch (error) {
    console.error('Error fetching books:', error);
  }
};

onMounted(() => {
  fetchBooks();
});
</script>

<style scoped>
</style>
